import { useApiMutation } from '../../../utils'
import {
    UpdateDeviceConfigMutationSchema,
    UpdateDeviceConfigMutationVariablesSchema,
    type UpdateDeviceConfigMutationVariables
} from '../device_schemas'

export const useUpdateDeviceConfigMutation = () => {
    const { mutateAsync, isPending, error } = useApiMutation<
        UpdateDeviceConfigMutationVariables,
        typeof UpdateDeviceConfigMutationSchema
    >('/platform/device/update_device_config', UpdateDeviceConfigMutationSchema)

    const updateDeviceConfig = async (input: UpdateDeviceConfigMutationVariables) => {
        const variables = UpdateDeviceConfigMutationVariablesSchema.parse(input)
        return mutateAsync(variables)
    }

    return { updateDeviceConfig, loading: isPending, error }
}
